import React, { useEffect, useState } from "react";
import {
  CModal,
  CModalBody,
} from "@coreui/react";



import Select from "react-select";


import { useDispatch, } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg"; 
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { hideAddFaqsModal, showAddFaqsModal } from "../redux/faqsModalDispatcher";

import { addFaqsRequest } from "../redux/faqsDispatcher";





const AddFaqs = ({
   buttonLabel = "Add Faq", 
   editMode = false,
   faqsData = {},
   }) => {



          

  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false); // Local State

  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");

  useEffect(() => {

    if (editMode && faqsData) {

      setQuestion(faqsData.question || "");
      setAnswer(faqsData.answer || "");
    } 
  }, [editMode, faqsData]);



  const resetForm = () => {
    setQuestion("");
    setAnswer("");
  };



  // Handle Add Faqs Submission
  const handleAddFaqs = () => {



    if (question.trim() === "") {
      alert("Question is required");
      return;
    }

       if (answer.trim() === "") {
      alert("Answer is required");
      return;
    }


    var data = {
      "question":question,
      "answer":answer,
          };
     

      if(editMode){
        data.id = faqsData.id;
      }

    dispatch(addFaqsRequest(data));
  
    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddFaqsModal());
  };

  return (
    <div>
      {/* Button to Open Modal */}
         <button
                onClick={() => {
                  if (!editMode) {
                    resetForm(); // Reset the form if adding
                  }
                  setIsModalVisible(true)
                  dispatch(showAddFaqsModal())

                }}
                style={{
                  backgroundColor: editMode==true?"#1b87f4":"rgb(0 0 0)",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "4px",
                  fontSize:editMode==true?"10px":"14px",
                  minWidth:"60px",
                  // width: "100%",
                  height: editMode==true?"24px":"30px",  // Increased height
                  padding: editMode==true?"2px 5px":"4px 10px", // Added padding
                  display: "flex",
                  alignItems: "center",
                  // alignSelf:"end",
                  justifyContent: "center",
                }}
              >{buttonLabel}</button>
    
      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() =>setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          {/* Close Button */}
          <div className="cross-btn-div d-flex">
              <img
                onClick={() =>setIsModalVisible(false)}
                src={crossButton}
                alt="close"
                className="cross-button"
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
              <div className="mb-4">
                <h4
                  className="h4 fw-bold"
                  style={{ color: "#007bff", textAlign:"center" }}
                >
                  <b>{editMode===true? ("Edit FAQ") : ("Add FAQ")}</b>
                </h4>
              </div>

            



              {/* Question Input */}
              <div className="mb-3 input-login-box">
                <input
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  name="question"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter question"
                />
              </div>



              <div className="mb-3 input-login-box">
              
     {/* Answer Input */}
              <div className="mb-3 input-login-box">
                <input
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  name="answer"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter answer"
                />
              </div>

              </div>

        

              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddFaqs}
              >
                  {editMode ? "Update" : "Submit"}
              </button>
            </form>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddFaqs;
